import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import CoworkerSignatoryWidget from '../../../widgets/coworkerSignatoryWidget/CoworkerSignatoryWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSignContract } from '../../../redux/actions/contract'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import AttachFilesContractWidget from '../../../widgets/attachfiles/AttachFilesContractWidget'

export default function CoworkerSignatory() {
  //ภาคีลงลงนาม
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    //projectId && handleGetSchema(projectId)
    setSchema(mockSchemas.model)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSignContract(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets
            showCommandButton={true}
            formSchema={schema.forms.agreementDetails}
          />
        )}

        {schema?.forms?.contractFile && (
          <AttachFilesContractWidget schema={schema?.forms?.contractFile} isContractFile={true} />
        )}

        {schema?.forms?.attachmentGrantee && (
          <AttachFilesContractWidget schema={schema?.forms?.attachmentGrantee} />
        )}

        {schema?.forms?.requestNote && (
          <CoworkerSignatoryWidget showCommandButton={true} schema={schema.forms.requestNote} />
        )}
        <br />
      </SidebarProposal>
    </>
  )
}

const mockSchemas = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ลงนามสัญญา/ข้อตกลง',
    subHeader: null,
    forms: {
      requestNote: {
        header: 'ลงนามสัญญา/ข้อตกลง',
        buttonText: 'ลงนามสัญญา/ข้อตกลง',
      },
      agreementDetails: {
        title: 'ลงนามสัญญา/ข้อตกลง',
        content: '',
        datetime: {
          dateLabel: 'วันที่ : ',
          dateValue: '15 กันยายน 2564',
          timeLabel: 'เวลา : ',
          timeValue: '02:25',
        },
        status: {
          statusLabel: 'สถานะ : ',
          statusValue: 'รอลงนาม',
        },
      },
      contractFile: {
        header: 'รายการไฟล์ประกอบการทำสัญญา',
        buttonText: null,
        attachFiles: {
          id: null,
          name: null,
          description: null,
          buttonText: null,
          value: [
            {
              contractFileTypeId: null,
              contractFileType: null,
              uploadDate: null,
              isChecked: false,
              enableDelete: false,
              isRequired: false,
              label: 'ข้อเสนอโครงการ',
              name: 'proposal',
              path: 'files/proposal/E3B3866B-72A6-452C-AC94-619770B3510D.pdf',
              type: null,
              size: 0,
              id: '906A5CB4-4935-4D4E-8B26-02B4A347CE40',
            },
            {
              contractFileTypeId: null,
              contractFileType: null,
              uploadDate: null,
              isChecked: false,
              enableDelete: false,
              isRequired: false,
              label: 'สัญญา',
              name: 'contract',
              path: 'files/contract/4C5B56F6-C7FA-4E95-8C8D-347CBAE5106D.pdf',
              type: null,
              size: 0,
              id: '0384A2AD-8ACE-4CB8-97B2-085C608C4C2F',
            },
          ],
        },
      },
      attachmentGrantee: {
        header: 'รายการไฟล์คุณสมบัติผู้รับทุน',
        buttonText: null,
        attachFiles: {
          id: null,
          name: null,
          description: null,
          buttonText: null,
          value: [
            {
              contractFileTypeId: '27DE34FC-D460-46BB-9055-F706DCE89859',
              contractFileType: 'เอกสารคุณสมบัติอื่นๆ (ถ้ามี)',
              uploadDate: '2021-09-15T18:58:09.9',
              isChecked: false,
              enableDelete: true,
              isRequired: true,
              label: '8118.jpg',
              name: '8118.jpg',
              path: 'contract/attachment/8C71989A-F623-4805-8153-69CD632CA091.jpg',
              type: null,
              size: 0,
              id: '7F529143-D822-45BA-A2A8-8C6092134F6E',
            },
            {
              contractFileTypeId: '6DA68B8E-624B-4F10-882A-CDB0C1A3918D',
              contractFileType: 'สำเนาบัตรประจำตัวผู้เสียภาษีขององค์กร ที่กรมสรรพากรออกให้',
              uploadDate: '2021-09-15T18:58:15.18',
              isChecked: false,
              enableDelete: true,
              isRequired: true,
              label: '1logo น้ำพริก.png',
              name: '1logo น้ำพริก.png',
              path: 'contract/attachment/6878B0A6-9B80-4CF9-908B-121F5D3B41CD.png',
              type: null,
              size: 0,
              id: '8D1854C1-59A6-46C0-AF2D-A81ACFC072F2',
            },
            {
              contractFileTypeId: '90BC6EA0-18E9-4FD7-8AC0-05545ECDB21E',
              contractFileType:
                'สำเนาหน้าบัญชีธนาคารที่แสดงเลขที่บัญชีเงินฝากออมทรัพย์ชื่อบัญชี ชื่อธนาคาร-สาขา',
              uploadDate: '2021-09-15T18:58:27.263',
              isChecked: false,
              enableDelete: true,
              isRequired: true,
              label: '1logo น้ำพริก.png',
              name: '1logo น้ำพริก.png',
              path: 'contract/attachment/0C3D559B-841B-41DE-B2F1-75D32744F5BA.png',
              type: null,
              size: 0,
              id: 'ADBD6316-C8FA-450B-90CC-33F1AF0C24F2',
            },
            {
              contractFileTypeId: '0F6A0F9B-F8B1-4046-A656-89D8801F714C',
              contractFileType: 'สำเนาใบทะเบียนภาษีมูลค่าเพิ่ม (ภพ.20)',
              uploadDate: '2021-09-15T18:58:30.473',
              isChecked: false,
              enableDelete: true,
              isRequired: true,
              label: '1logo ด้านข้าง.png',
              name: '1logo ด้านข้าง.png',
              path: 'contract/attachment/21B4A4F5-6765-4466-8C8B-59321CBEAA77.png',
              type: null,
              size: 0,
              id: 'D11FD69A-B560-4A61-B0D4-346FD506AB1D',
            },
          ],
        },
      },
    },
  },
}
